import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loggedInUser: {},
        userAccounts: [],
        activeToken: "",
        isBusinessAccount: false,
        account: null,
        selectedCompany: null,
        isAdmin: false,
        isSuperAdmin: false,
        companyToView: null,
        companyToEdit: false,
        callReportCategory: "",
        sales_forecast_length: 0,
        user_permissions: {},
        call_report_type:"",
        checkBrowser: "",
        session_id: null,
        user_id: null,
        fcm_details: {
            fcm_token: "",
            fcm_server_key: ""
        }
    },
    // Getters for All Permissions
    getters: {
        loggedInUser: state => state.loggedInUser,
        userAccounts: state => state.userAccounts,
        activeToken: state => state.activeToken,
        isBusinessAccount: state => state.isBusinessAccount,
        account: state => state.account,
        selectedCompany: state => state.selectedCompany,
        isAdmin: state => state.isAdmin,
        isSuperAdmin: state => state.isSuperAdmin,
        companyToView: state => state.companyToView,
        companyToEdit: state => state.companyToEdit,
        callReportCategory: state => state.callReportCategory,
        salesForeCastLength: state => state.sales_forecast_length,
        userPermissions: state => state.user_permissions,
        callReportType: state => state.call_report_type,
        checkBrowser: state => state.checkBrowser,
        session_id: state => state.session_id,
        user_id: state => state.user_id,
        fcmDetails: state => state.fcm_details,
        session_id: state => state.session_id,
        user_id: state => state.user_id,
    },
    mutations: {
        setLoggedInUser(state, user) {
            state.loggedInUser = user;
        },
        setUserAccounts(state, accounts) {
            state.userAccounts = accounts;
        },
        setToken(state, token) {
            state.activeToken = token;
        },
        changeAccountType(state, bool) {
            state.isBusinessAccount = bool;
        },
        switchAccount(state, company_id) {
            state.account = company_id;
        },
        setSelectedCompany(state, company_data) {
            state.selectedCompany = company_data;
        },
        setAdminSuperAdmin(state, data) {
            state.isAdmin = data.isAdmin;
            state.isSuperAdmin = data.isSuperAdmin
        },
        setCompanyToView(state, company_id, type) {
            state.companyToView = company_id;
            state.companyToEdit = false;
        },
        setCompanyToEdit(state) {
            state.companyToEdit = true;
        },
        setCallReportCategory(state, category) {
            state.callReportCategory = category;
        },
        setSalesForecastLength(state, sales_forecast) {
            state.sales_forecast_length = sales_forecast;
        },
        setUserPermissions(state, user_permissions) {
            state.user_permissions = user_permissions;
        },
        setCallReportType(state, call_report_type) {
            state.call_report_type = call_report_type
        },
        setCheckBrowser(state, checkBrowser) {
            state.checkBrowser = checkBrowser
        },
        setSessionId(state, session_id) {
            state.session_id = session_id
        },
        setUserId(state, user_id) {
            state.user_id = user_id
        },
        setFCMDetails(state, fcm_details) {
            state.fcm_details = fcm_details
        },
    },
});


// WEBPACK FOOTER //
// ./src/store.js